import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import * as contractorActions from '../contractorActions';
import valueFilters from '../valueFilters';
import contractorUpgradeFactory from '../models/contractorUpgradeModel';
import { Confirm, CurrencyInput, Popup } from './sharedComponents';

const ContextMenu = ({ duplicateAction, deleteAction, isValid }) => {
	const onDuplicateClicked = (e) => {
		e.preventDefault();
		if (!isValid) { return; }
		duplicateAction();
	};
	const onDeleteClicked = (e) => {
		e.preventDefault();
		deleteAction();
	};

	return	(<div className="content scrollable">
		<ul className="menu">
			<li className={ !isValid ? 'disabled' : ''}><a className="button icon iconLabel duplicateItem" onClick={ onDuplicateClicked }><span>Duplicate</span></a></li>
			<li><a className="button icon iconLabel removeItem delete" onClick={ onDeleteClicked }><span>Delete</span></a></li>
		</ul>
	</div>);
};

class UpgradeRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { shouldValidate: this.props.alwaysValidate };

		this.handleButtonClick = this.handleButtonClick.bind(this);
	}

	validate (property?) {
		if (!property || this.state.shouldValidate) {
			const result = !this.props.upgrade.test(property);

			return result;
		}
		return true;
	}

	handleButtonClick (e) {
		e.preventDefault();

		const valid = this.validate();

		if (!valid) {
			this.setState({ shouldValidate: true });
		}
		else {
			// this assumes that the add handler succeeds
			this.setState({ shouldValidate: this.props.alwaysValidate });
		}

		this.props.buttonHandler(valid, e);
	}

	updateModel (path, autoSave, e) {
		const newVal = autoSave ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(upgrade => {
			upgrade.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	render () {
		const { buttonClasses, classNames, upgrade } = this.props;

		return (<tr className={ classNames.join(' ')}>
			<td />
			<td className={(!this.validate('description') ? 'required' : '')}><textarea className="lineItemDescription" placeholder="Enter a Description" autoCapitalize="" autoCorrect="off" value={ upgrade.viewValue('description') } onChange={ this.updateModel.bind(this, 'description', false) } onBlur={ this.updateModel.bind(this, 'description', true) } /></td>
			<td className={(!this.validate('sellPrice') ? 'price required' : 'price')}><CurrencyInput placeholder="0.00" value={ upgrade.viewValue('sellPrice') } onChange={ this.updateModel.bind(this, 'sellPrice', false) } onBlur={ this.updateModel.bind(this, 'sellPrice', true) } /></td>
			<td><button className={buttonClasses.join(' ')} onClick={ this.handleButtonClick }><span /></button></td>
			<td />
		</tr>);
	}
}

class UpgradeTable extends React.Component<any,any> {
	private _pendingUpgrade;

	constructor (props) {
		super(props);

		this._pendingUpgrade = this.createPendingUpgrade(props);
	}

	addPaymentHandler (upgradeKey, isValid) {
		if (!isValid) { return; }

		this.props.updateModel(job => {
			if (upgradeKey === this._pendingUpgrade.key) {
				job.upgrades.add(this._pendingUpgrade);

				this._pendingUpgrade = this.createPendingUpgrade(this.props as any);
			}
		}, { autoSave: true });
	}

	createPendingUpgrade ({ contractor, upgradeType }) {
		return contractorUpgradeFactory({ contractorKey: contractor.key, upgradeType });
	}

	contextMenuHandler (upgradeKey, isValid, e) {
		const popup = <Popup target={e.target}><ContextMenu duplicateAction={this.duplicateUpgrade.bind(this, upgradeKey)} deleteAction={this.deleteUpgrade.bind(this, upgradeKey)} isValid={ isValid } /></Popup>;
		actions.pushModal({ component: popup });
	}

	deleteUpgrade (upgradeKey) {
		actions.popModal();

		const deleter = () => {
			actions.popModal();

			this.props.updateModel(contractor => {
				contractor.upgrades.delete(upgradeKey);
			}, { autoSave: true });
		};

		actions.pushModal({
			component: <Confirm title="Delete Upgrade?" message="Are you sure you want to remove this upgrade?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ deleter } />
		});
	}

	duplicateUpgrade (upgradeKey) {
		actions.popModal();
		this.props.updateModel(contractor => {
			const upgrade = contractor.upgrades.get(upgradeKey);

			if (upgrade) {
				contractor.upgrades.add(contractorUpgradeFactory(_.omit(upgrade.toDocument(), 'key', 'relayId')));
			}
		}, { autoSave: true });
	}

	updateModel (key, updater, options) {
		const pendingUpgrade = this._pendingUpgrade;

		this.props.updateModel(contractor => {
			let upgrade = contractor.upgrades.get(key);

			if (!upgrade && key === pendingUpgrade.key) {
				upgrade = pendingUpgrade;
				options.autoSave = false;
			}

			if (upgrade) {
				updater(upgrade);
			}
		}, options);
	}

	render () {
		const { contractor, upgradeType } = this.props;
		const pendingUpgrade = this._pendingUpgrade;

		const rows = _.map(_.sortBy(_.filter(contractor.upgrades, { upgradeType }), ['description']), upgrade => {
			return <UpgradeRow key={ upgrade.key } upgrade={upgrade} classNames={['added']} updateModel={ this.updateModel.bind(this, upgrade.key) } buttonHandler={ this.contextMenuHandler.bind(this, upgrade.key) } buttonClasses={['icon', 'iconOnly', 'contextMenu']} alwaysValidate={ true } />;
		});

		rows.unshift(<UpgradeRow key={ pendingUpgrade.key } upgrade={pendingUpgrade} classNames={[]} updateModel={ this.updateModel.bind(this, pendingUpgrade.key) } buttonHandler={ this.addPaymentHandler.bind(this, pendingUpgrade.key) } buttonClasses={['icon', 'iconOnly', 'addItem']}/>);

		return (<table className="compact" cellPadding="0" cellSpacing="0">
			<thead>
				<tr>
					<td />
					<td><span className="readOnly">Description</span></td>
					<td className="price"><span className="readOnly">Sell Price</span></td>
					<td className="action" />
					<td />
				</tr>
			</thead>
			<tbody>
				{ rows }
			</tbody>
		</table>);
	}
}

export default class ContractorUpgrades extends React.Component<any,any> {
	constructor (props) {
		super(props);
	}

	componentDidMount(): void {
		const { contractor } = this.props;

		if (contractor) {
			// this will ensure the latest upgrades are pulled
			contractorActions.fetchContractor({ key: contractor.key });
		}
	}

	render () {
		const { contractor, updateModel, upgradeType } = this.props;

		if (!contractor) { return null; }

		return (
			<div className="content jobDetail scrollable"><section className="expander expanded"><div className="inner"><UpgradeTable contractor={ contractor } upgradeType={ upgradeType } updateModel={ updateModel } /></div></section></div>);
	}
}